function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchBitacoraVersions, getVersionsQueryKey } from "./actions/BitacoraVersionActions";
import { deletePolizaComment, updatePolizaComment, fetchPolizaComment } from "./actions/PolizaCommentActions";
import { deletePolizaFile, updatePolizaFile, fetchPolizaFile, createPolizaFile } from "./actions/PolizaFileActions";
import * as moment from "moment"; // Componente Modal para mostrar archivos

var FileModal = function FileModal(props) {
  var fileUrl = props.fileUrl,
      fileName = props.fileName,
      onClose = props.onClose;
  React.useEffect(function () {
    // Prevenir scroll del body cuando el modal está abierto
    document.body.style.overflow = "hidden";
    return function () {
      document.body.style.overflow = "unset";
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "20px"
    },
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      maxWidth: "90%",
      maxHeight: "90%",
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)"
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "15px 20px",
      borderBottom: "1px solid #dee2e6",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#f8f9fa",
      borderRadius: "8px 8px 0 0"
    }
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      margin: 0,
      fontSize: "16px",
      fontWeight: "600",
      color: "#333"
    }
  }, fileName), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    style: {
      background: "none",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
      color: "#666",
      padding: "0",
      width: "30px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "4px"
    },
    onMouseEnter: function onMouseEnter(e) {
      e.currentTarget.style.backgroundColor = "#e9ecef";
    },
    onMouseLeave: function onMouseLeave(e) {
      e.currentTarget.style.backgroundColor = "transparent";
    }
  }, "\xD7")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflow: "auto",
      padding: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    src: fileUrl,
    style: {
      width: "100%",
      height: "100%",
      border: "none"
    },
    title: fileName
  }))));
};

var MANAGEMENT_TYPES = [{
  value: "cotizacion",
  label: "Cotización enviada"
}, {
  value: "seguimiento",
  label: "Seguimiento comercial"
}, {
  value: "renovacion",
  label: "Renovación cerrada"
}, {
  value: "siniestro",
  label: "Siniestro"
}, {
  value: "otro",
  label: "Otro"
}];
var CONTACT_METHODS = [{
  value: "email",
  label: "Email"
}, {
  value: "telefono",
  label: "Teléfono"
}, {
  value: "whatsapp",
  label: "WhatsApp"
}, {
  value: "reunion",
  label: "Reunión"
}, {
  value: "presencial",
  label: "Presencial"
}];
var STATUS_OPTIONS = [{
  value: "pendiente",
  label: "Pendiente"
}, {
  value: "en_proceso",
  label: "En proceso"
}, {
  value: "cerrado",
  label: "Cerrado"
}];
var FILE_TYPES = [{
  value: "mandato_pac_pat_firmado",
  label: "MANDATO PAC/PAT FIRMADO (ESCANEADO)"
}, {
  value: "comprobante_pago",
  label: "COMPROBANTE DE PAGO (ESCANEADO)"
}, {
  value: "padron_auto",
  label: "PADRÓN AUTO"
}, {
  value: "plan_pago",
  label: "PLAN DE PAGO"
}, {
  value: "ordenes_compra",
  label: "ORDENES DE COMPRA (LICITACIONES)"
}, {
  value: "carta_banco",
  label: "CARTA BANCO"
}, {
  value: "certificados_varios",
  label: "CERTIFICADOS VARIOS (cobertura, pago al contado)"
}];

var VersionHistorySection = function VersionHistorySection(props) {
  var polizaId = props.polizaId,
      admin = props.admin,
      token = props.token;
  var indexQueryKey = getVersionsQueryKey(polizaId);
  var queryClient = useQueryClient();

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      modalFile = _React$useState2[0],
      setModalFile = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      editingRow = _React$useState4[0],
      setEditingRow = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      editData = _React$useState6[0],
      setEditData = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      loadingEdit = _React$useState8[0],
      setLoadingEdit = _React$useState8[1];

  var _useQuery = useQuery({
    queryKey: indexQueryKey,
    queryFn: function queryFn() {
      return fetchBitacoraVersions(polizaId);
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 30000
  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      error = _useQuery.error;

  var versions = (data === null || data === void 0 ? void 0 : data.versions) || []; // Debug: ver qué versiones estamos recibiendo

  var formatDate = function formatDate(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY");
  };

  var formatDateTime = function formatDateTime(dateString) {
    if (!dateString) return "";
    return moment(dateString).format("DD/MM/YYYY HH:mm");
  };

  var getManagementTypeLabel = function getManagementTypeLabel(value) {
    var types = {
      cotizacion: "Cotización enviada",
      seguimiento: "Seguimiento comercial",
      renovacion: "Renovación cerrada",
      siniestro: "Siniestro",
      otro: "Otro"
    };
    return types[value] || value;
  };

  var getContactMethodLabel = function getContactMethodLabel(value) {
    var methods = {
      email: "Email",
      telefono: "Teléfono",
      whatsapp: "WhatsApp",
      reunion: "Reunión",
      presencial: "Presencial"
    };
    return methods[value] || value;
  };

  var getStatusLabel = function getStatusLabel(value) {
    var statuses = {
      pendiente: "Pendiente",
      en_proceso: "En proceso",
      cerrado: "Cerrado"
    };
    return statuses[value] || value;
  };

  var handleDeleteComment = function handleDeleteComment(itemId) {
    return deletePolizaComment(itemId, token).then(function () {
      queryClient.invalidateQueries({
        queryKey: indexQueryKey
      });
    })["catch"](function (error) {
      console.error("Error deleting comment:", error);
      alert("Error al eliminar el comentario. Por favor, intenta de nuevo.");
      throw error;
    });
  };

  var handleDeleteFile = function handleDeleteFile(itemId) {
    return deletePolizaFile(itemId, token).then(function () {
      queryClient.invalidateQueries({
        queryKey: indexQueryKey
      });
    })["catch"](function (error) {
      console.error("Error deleting file:", error);
      alert("Error al eliminar el archivo. Por favor, intenta de nuevo.");
      throw error;
    });
  };

  var handleStartEdit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(row, rowIndex) {
      var currentData, _file, _file2, _comment, _comment$management_t, _comment2, _comment$contact_meth, _comment3, _comment$next_step, _comment4, _comment$status, _comment5, _file$file_type, _file3, _file4, _file5, comment, file, fileName, _comment6$management_, _comment6$contact_met, _comment6$next_step, _comment6$status, _comment6, _file6$file_type, _file6, _fileName;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoadingEdit(true);
              _context.prev = 1;

              if (row) {
                _context.next = 4;
                break;
              }

              throw new Error("No se pudo obtener la información de la fila");

            case 4:
              currentData = {}; // Si la fila tiene ambos (comentario + archivo), cargar ambos

              if (!row.hasBoth) {
                _context.next = 50;
                break;
              }

              if (!(!row.commentId && !row.fileId)) {
                _context.next = 8;
                break;
              }

              throw new Error("La fila combinada no tiene IDs de comentario ni archivo");

            case 8:
              // Cargar comentario y archivo por separado para mejor manejo de errores
              comment = null;
              file = null;

              if (!row.commentId) {
                _context.next = 21;
                break;
              }

              _context.prev = 11;
              _context.next = 14;
              return fetchPolizaComment(row.commentId);

            case 14:
              comment = _context.sent;
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](11);
              console.error("Error fetching comment:", _context.t0);
              throw new Error("Error al cargar el comentario: ".concat(_context.t0.message || "Error desconocido"));

            case 21:
              if (!row.fileId) {
                _context.next = 32;
                break;
              }

              _context.prev = 22;
              _context.next = 25;
              return fetchPolizaFile(row.fileId);

            case 25:
              file = _context.sent;
              _context.next = 32;
              break;

            case 28:
              _context.prev = 28;
              _context.t1 = _context["catch"](22);
              console.error("Error fetching file:", _context.t1);
              throw new Error("Error al cargar el archivo: ".concat(_context.t1.message || "Error desconocido"));

            case 32:
              if (!(row.commentId && !comment)) {
                _context.next = 34;
                break;
              }

              throw new Error("No se pudo cargar el comentario con ID ".concat(row.commentId));

            case 34:
              // Procesar el nombre del archivo de manera segura
              // Priorizar file_name del backend, luego file.file
              fileName = null;

              if ((_file = file) !== null && _file !== void 0 && _file.file_name) {
                fileName = file.file_name;
              } else if ((_file2 = file) !== null && _file2 !== void 0 && _file2.file) {
                if (typeof file.file === 'string') {
                  fileName = file.file;
                } else if (file.file && typeof file.file === 'object') {
                  // Si es un objeto, intentar obtener el filename
                  fileName = file.file.filename || file.file.toString() || null;
                }
              }

              currentData = {
                // Datos del comentario - mantener valores originales tal cual
                content: ((_comment = comment) === null || _comment === void 0 ? void 0 : _comment.content) || "",
                management_type: (_comment$management_t = (_comment2 = comment) === null || _comment2 === void 0 ? void 0 : _comment2.management_type) !== null && _comment$management_t !== void 0 ? _comment$management_t : null,
                contact_method: (_comment$contact_meth = (_comment3 = comment) === null || _comment3 === void 0 ? void 0 : _comment3.contact_method) !== null && _comment$contact_meth !== void 0 ? _comment$contact_meth : null,
                next_step: (_comment$next_step = (_comment4 = comment) === null || _comment4 === void 0 ? void 0 : _comment4.next_step) !== null && _comment$next_step !== void 0 ? _comment$next_step : null,
                status: (_comment$status = (_comment5 = comment) === null || _comment5 === void 0 ? void 0 : _comment5.status) !== null && _comment$status !== void 0 ? _comment$status : null,
                // Datos del archivo - mantener valores originales tal cual
                file_type: (_file$file_type = (_file3 = file) === null || _file3 === void 0 ? void 0 : _file3.file_type) !== null && _file$file_type !== void 0 ? _file$file_type : null,
                // Información del archivo actual para referencia
                current_file_id: ((_file4 = file) === null || _file4 === void 0 ? void 0 : _file4.id) || null,
                current_file_name: fileName,
                current_file_url: ((_file5 = file) === null || _file5 === void 0 ? void 0 : _file5.file_url) || null,
                // Nuevo archivo a subir (si el usuario selecciona uno)
                new_file: null,
                // Flag para eliminar el archivo actual
                delete_file: false
              }; // Validar que currentData tenga la estructura correcta antes de establecerlo

              if (!(!currentData || typeof currentData !== 'object')) {
                _context.next = 39;
                break;
              }

              throw new Error("Error al preparar los datos para editar");

            case 39:
              _context.prev = 39;
              setEditData(currentData);
              setEditingRow(rowIndex);
              _context.next = 48;
              break;

            case 44:
              _context.prev = 44;
              _context.t2 = _context["catch"](39);
              console.error("Error setting editData:", _context.t2);
              throw new Error("Error al establecer los datos para editar");

            case 48:
              _context.next = 68;
              break;

            case 50:
              if (!(row.itemType === "PolizaComment")) {
                _context.next = 59;
                break;
              }

              if (row.itemId) {
                _context.next = 53;
                break;
              }

              throw new Error("No se pudo obtener el ID del comentario");

            case 53:
              _context.next = 55;
              return fetchPolizaComment(row.itemId)["catch"](function (err) {
                console.error("Error fetching comment:", err);
                throw new Error("No se pudo cargar el comentario con ID ".concat(row.itemId));
              });

            case 55:
              _comment6 = _context.sent;
              // Mantener los valores originales tal cual (null si es null, string si tiene valor)
              // Solo content debe ser string siempre (es requerido)
              currentData = {
                content: _comment6.content || "",
                management_type: (_comment6$management_ = _comment6.management_type) !== null && _comment6$management_ !== void 0 ? _comment6$management_ : null,
                contact_method: (_comment6$contact_met = _comment6.contact_method) !== null && _comment6$contact_met !== void 0 ? _comment6$contact_met : null,
                next_step: (_comment6$next_step = _comment6.next_step) !== null && _comment6$next_step !== void 0 ? _comment6$next_step : null,
                status: (_comment6$status = _comment6.status) !== null && _comment6$status !== void 0 ? _comment6$status : null,
                // Permitir agregar archivo a un comentario que no tiene
                current_file_id: null,
                current_file_name: null,
                current_file_url: null,
                new_file: null,
                delete_file: false,
                // Archivos adicionales para agregar
                additional_files: []
              };
              _context.next = 68;
              break;

            case 59:
              if (!(row.itemType === "PolizaFile")) {
                _context.next = 68;
                break;
              }

              if (row.itemId) {
                _context.next = 62;
                break;
              }

              throw new Error("No se pudo obtener el ID del archivo");

            case 62:
              _context.next = 64;
              return fetchPolizaFile(row.itemId)["catch"](function (err) {
                console.error("Error fetching file:", err);
                throw new Error("No se pudo cargar el archivo con ID ".concat(row.itemId));
              });

            case 64:
              _file6 = _context.sent;
              // Procesar el nombre del archivo de manera segura
              // Priorizar file_name del backend, luego file.file
              _fileName = null;

              if (_file6 !== null && _file6 !== void 0 && _file6.file_name) {
                _fileName = _file6.file_name;
              } else if (_file6 !== null && _file6 !== void 0 && _file6.file) {
                if (typeof _file6.file === 'string') {
                  _fileName = _file6.file;
                } else if (_file6.file && typeof _file6.file === 'object') {
                  _fileName = _file6.file.filename || _file6.file.toString() || null;
                }
              } // Mantener los valores originales tal cual


              currentData = {
                file_type: (_file6$file_type = _file6.file_type) !== null && _file6$file_type !== void 0 ? _file6$file_type : null,
                current_file_id: (_file6 === null || _file6 === void 0 ? void 0 : _file6.id) || null,
                current_file_name: _fileName,
                current_file_url: (_file6 === null || _file6 === void 0 ? void 0 : _file6.file_url) || null,
                new_file: null,
                delete_file: false,
                // Archivos adicionales para agregar
                additional_files: []
              };

            case 68:
              if (!(!currentData || typeof currentData !== 'object')) {
                _context.next = 70;
                break;
              }

              throw new Error("Error al preparar los datos para editar");

            case 70:
              _context.prev = 70;
              setEditData(currentData);
              setEditingRow(rowIndex);
              _context.next = 79;
              break;

            case 75:
              _context.prev = 75;
              _context.t3 = _context["catch"](70);
              console.error("Error setting editData:", _context.t3);
              throw new Error("Error al establecer los datos para editar");

            case 79:
              _context.next = 85;
              break;

            case 81:
              _context.prev = 81;
              _context.t4 = _context["catch"](1);
              console.error("Error loading data for edit:", _context.t4);
              alert("Error al cargar los datos para editar. Por favor, intenta de nuevo.");

            case 85:
              _context.prev = 85;
              setLoadingEdit(false);
              return _context.finish(85);

            case 88:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 81, 85, 88], [11, 17], [22, 28], [39, 44], [70, 75]]);
    }));

    return function handleStartEdit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleCancelEdit = function handleCancelEdit() {
    setEditingRow(null);
    setEditData(null);
  };

  var handleSaveEdit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(row) {
      var promises, updateData, currentFile, fileUpdateData, _fileUpdateData, _updateData, _currentFile, _fileUpdateData2, _fileUpdateData3;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (editData) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              setLoadingEdit(true);
              _context2.prev = 3;
              // editData ya contiene todos los valores actuales (cargados al iniciar edición)
              // Si el usuario editó un campo, tiene el nuevo valor
              // Si no lo editó, mantiene el valor original que cargamos (puede ser null o string)
              // Enviamos todos los valores tal como están en editData (preservando null si era null)
              promises = []; // Si la fila tiene ambos (comentario + archivo), guardar ambos

              if (!row.hasBoth) {
                _context2.next = 19;
                break;
              }

              if (row.commentId) {
                // editData ya contiene todos los campos del comentario cargados al iniciar la edición
                // Enviar todos los campos tal como están en editData para preservar los valores originales
                updateData = {
                  id: row.commentId,
                  content: editData.content || "",
                  // Enviar todos los campos que están en editData (fueron cargados al iniciar edición)
                  // Si el usuario no editó un campo, mantiene su valor original
                  management_type: editData.hasOwnProperty('management_type') ? editData.management_type || null : undefined,
                  contact_method: editData.hasOwnProperty('contact_method') ? editData.contact_method || null : undefined,
                  next_step: editData.hasOwnProperty('next_step') ? editData.next_step || null : undefined,
                  status: editData.hasOwnProperty('status') ? editData.status || null : undefined
                };
                promises.push(updatePolizaComment(updateData, token));
              }

              if (!row.fileId) {
                _context2.next = 14;
                break;
              }

              _context2.next = 10;
              return fetchPolizaFile(row.fileId);

            case 10:
              currentFile = _context2.sent;

              // Si hay un nuevo archivo, actualizar el existente (reemplazar) en lugar de eliminar y crear
              // Esto mantiene el mismo itemId y evita duplicados
              if (editData.new_file instanceof File) {
                fileUpdateData = {
                  id: row.fileId,
                  file: editData.new_file // Reemplazar el archivo

                }; // Incluir file_type si está definido

                if (editData.hasOwnProperty('file_type')) {
                  fileUpdateData.file_type = editData.file_type || null;
                }

                promises.push(updatePolizaFile(fileUpdateData, token));
              } else if (editData.delete_file) {
                // Solo eliminar si no hay nuevo archivo para reemplazar
                promises.push(deletePolizaFile(row.fileId, token));
              } else {
                // Actualizar solo metadata (tipo) sin cambiar el archivo
                _fileUpdateData = {
                  id: row.fileId
                }; // Solo incluir file_type si cambió respecto al valor original

                if (editData.hasOwnProperty('file_type') && editData.file_type !== currentFile.file_type) {
                  _fileUpdateData.file_type = editData.file_type || null;
                } // Solo actualizar si hay algo que cambiar (más que solo el id)


                if (Object.keys(_fileUpdateData).length > 1) {
                  promises.push(updatePolizaFile(_fileUpdateData, token));
                }
              }

              _context2.next = 15;
              break;

            case 14:
              if (editData.new_file instanceof File && editData.file_type) {
                // Si no hay archivo existente pero se quiere agregar uno nuevo
                promises.push(createPolizaFile({
                  poliza_id: polizaId,
                  file: editData.new_file,
                  file_type: editData.file_type
                }, token));
              }

            case 15:
              _context2.next = 17;
              return Promise.all(promises);

            case 17:
              _context2.next = 48;
              break;

            case 19:
              if (!(row.itemType === "PolizaComment")) {
                _context2.next = 27;
                break;
              }

              // Siempre enviar todos los campos que están en editData (fueron cargados al iniciar edición)
              // Si el usuario no editó un campo, mantiene su valor original
              _updateData = {
                id: row.itemId,
                content: editData.content || "",
                // Enviar todos los campos que están definidos en editData
                management_type: editData.hasOwnProperty('management_type') ? editData.management_type || null : undefined,
                contact_method: editData.hasOwnProperty('contact_method') ? editData.contact_method || null : undefined,
                next_step: editData.hasOwnProperty('next_step') ? editData.next_step || null : undefined,
                status: editData.hasOwnProperty('status') ? editData.status || null : undefined
              };
              promises.push(updatePolizaComment(_updateData, token)); // Si se agregó un nuevo archivo a un comentario que no tenía archivo

              if (editData.new_file instanceof File && editData.file_type) {
                promises.push(createPolizaFile({
                  poliza_id: polizaId,
                  file: editData.new_file,
                  file_type: editData.file_type
                }, token));
              }

              _context2.next = 25;
              return Promise.all(promises);

            case 25:
              _context2.next = 48;
              break;

            case 27:
              if (!(row.itemType === "PolizaFile")) {
                _context2.next = 48;
                break;
              }

              _context2.next = 30;
              return fetchPolizaFile(row.itemId);

            case 30:
              _currentFile = _context2.sent;

              if (!(editData.new_file instanceof File)) {
                _context2.next = 38;
                break;
              }

              _fileUpdateData2 = {
                id: row.itemId,
                file: editData.new_file // Reemplazar el archivo

              }; // Incluir file_type si está definido

              if (editData.hasOwnProperty('file_type')) {
                _fileUpdateData2.file_type = editData.file_type || null;
              }

              _context2.next = 36;
              return updatePolizaFile(_fileUpdateData2, token);

            case 36:
              _context2.next = 48;
              break;

            case 38:
              if (!editData.delete_file) {
                _context2.next = 43;
                break;
              }

              _context2.next = 41;
              return deletePolizaFile(row.itemId, token);

            case 41:
              _context2.next = 48;
              break;

            case 43:
              // Actualizar solo metadata (tipo) sin cambiar el archivo
              _fileUpdateData3 = {
                id: row.itemId
              }; // Solo incluir file_type si cambió respecto al valor original

              if (editData.hasOwnProperty('file_type') && editData.file_type !== _currentFile.file_type) {
                _fileUpdateData3.file_type = editData.file_type || null;
              } // Solo actualizar si hay algo que cambiar (más que solo el id)


              if (!(Object.keys(_fileUpdateData3).length > 1)) {
                _context2.next = 48;
                break;
              }

              _context2.next = 48;
              return updatePolizaFile(_fileUpdateData3, token);

            case 48:
              queryClient.invalidateQueries({
                queryKey: indexQueryKey
              });
              setEditingRow(null);
              setEditData(null);
              _context2.next = 57;
              break;

            case 53:
              _context2.prev = 53;
              _context2.t0 = _context2["catch"](3);
              console.error("Error saving:", _context2.t0);
              alert("Error al guardar los cambios. Por favor, intenta de nuevo.");

            case 57:
              _context2.prev = 57;
              setLoadingEdit(false);
              return _context2.finish(57);

            case 60:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 53, 57, 60]]);
    }));

    return function handleSaveEdit(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getRowData = function getRowData(version) {
    // No mostrar eventos de eliminación (destroy) como filas en el historial
    if (version.event === "destroy") {
      return null;
    }

    var changes = version.object_changes || {};
    var currentData = version.current_data || {}; // Para comentarios

    if (version.item_type === "PolizaComment") {
      var _changes$content, _changes$content2, _changes$management_t, _changes$management_t2, _changes$contact_meth, _changes$contact_meth2, _changes$next_step, _changes$next_step2;

      // Usar current_data si está disponible (datos actuales del registro)
      // Para versiones "create", los datos pueden estar solo en object_changes
      var content = currentData.content || ((_changes$content = changes.content) === null || _changes$content === void 0 ? void 0 : _changes$content[1]) || ((_changes$content2 = changes.content) === null || _changes$content2 === void 0 ? void 0 : _changes$content2[0]) || "";
      var managementType = currentData.management_type || ((_changes$management_t = changes.management_type) === null || _changes$management_t === void 0 ? void 0 : _changes$management_t[1]) || ((_changes$management_t2 = changes.management_type) === null || _changes$management_t2 === void 0 ? void 0 : _changes$management_t2[0]) || "";
      var contactMethod = currentData.contact_method || ((_changes$contact_meth = changes.contact_method) === null || _changes$contact_meth === void 0 ? void 0 : _changes$contact_meth[1]) || ((_changes$contact_meth2 = changes.contact_method) === null || _changes$contact_meth2 === void 0 ? void 0 : _changes$contact_meth2[0]) || "";
      var nextStep = currentData.next_step || ((_changes$next_step = changes.next_step) === null || _changes$next_step === void 0 ? void 0 : _changes$next_step[1]) || ((_changes$next_step2 = changes.next_step) === null || _changes$next_step2 === void 0 ? void 0 : _changes$next_step2[0]) || ""; // Para status, priorizar current_data, luego changes[1] (valor nuevo), luego changes[0] (valor inicial)
      // Si es una versión "create", changes[1] tendrá el valor inicial

      var status = undefined; // Primero intentar obtener desde current_data

      if (currentData.status !== null && currentData.status !== undefined && currentData.status !== "") {
        status = currentData.status;
      } // Si no hay status en current_data, intentar obtenerlo de object_changes


      if ((!status || status === "") && changes.status) {
        // Si es un array, tomar el último valor (el valor después del cambio)
        // Para "create", el formato es [null, "valor_inicial"]
        // Para "update", el formato es ["valor_anterior", "valor_nuevo"]
        if (Array.isArray(changes.status)) {
          // Tomar el último valor no-null del array
          for (var i = changes.status.length - 1; i >= 0; i--) {
            var val = changes.status[i];

            if (val !== null && val !== undefined && val !== "") {
              status = val;
              break;
            }
          }
        } else if (changes.status !== null && changes.status !== undefined && changes.status !== "") {
          status = changes.status;
        }
      } // Convertir a string vacío solo si realmente no hay valor


      var finalStatus = status !== null && status !== undefined && status !== "" ? status : "";
      var updatedAt = currentData.updated_at;
      var updatedByEmail = currentData.updated_by_email || version.whodunnit || "Desconocido"; // Usar created_at de current_data si está disponible (fecha de creación original del registro)
      // Si no, usar created_at de la versión (fecha de creación de la versión)

      var createdAt = currentData.created_at || version.created_at;
      var createdByEmail = currentData.created_by_email || version.whodunnit || "Desconocido"; // Solo mostrar fecha de edición si updated_at existe y es diferente de created_at
      // Usar una tolerancia de 1 segundo para evitar problemas de precisión

      var createdDate = new Date(createdAt).getTime();
      var updatedDate = updatedAt ? new Date(updatedAt).getTime() : null;
      var wasEdited = updatedDate && Math.abs(updatedDate - createdDate) > 1000; // Más de 1 segundo de diferencia

      var estadoLabel = finalStatus ? getStatusLabel(finalStatus) : "";
      return {
        fecha: formatDate(createdAt),
        fechaEdicion: wasEdited ? formatDate(updatedAt) : null,
        ejecutivo: createdByEmail,
        ejecutivoEdicion: wasEdited ? updatedByEmail : null,
        tipoGestion: managementType ? getManagementTypeLabel(managementType) : "",
        tipoGestionRaw: managementType,
        descripcion: content,
        medioContacto: contactMethod ? getContactMethodLabel(contactMethod) : "",
        medioContactoRaw: contactMethod,
        proximoPaso: nextStep,
        estado: estadoLabel,
        estadoRaw: finalStatus,
        archivo: "",
        itemType: version.item_type,
        itemId: version.item_id,
        canEdit: admin.is_super_admin || admin.permissions_code.includes("poliza_comment_edit"),
        canDelete: admin.is_super_admin || admin.permissions_code.includes("poliza_comment_delete")
      };
    } // Para archivos


    if (version.item_type === "PolizaFile") {
      var _changes$file_type, _changes$file_type2, _FILE_TYPES$find;

      var fileTypeRaw = currentData.file_type || ((_changes$file_type = changes.file_type) === null || _changes$file_type === void 0 ? void 0 : _changes$file_type[1]) || ((_changes$file_type2 = changes.file_type) === null || _changes$file_type2 === void 0 ? void 0 : _changes$file_type2[0]) || "";
      var fileTypeLabel = fileTypeRaw ? ((_FILE_TYPES$find = FILE_TYPES.find(function (ft) {
        return ft.value === fileTypeRaw;
      })) === null || _FILE_TYPES$find === void 0 ? void 0 : _FILE_TYPES$find.label) || fileTypeRaw : "";
      var fileName = version.file_name || "";
      var fileUrl = version.file_url || ""; // Extraer nombre del archivo desde el path si está disponible

      var displayFileName = fileName;

      if (fileName && fileName.includes("/")) {
        var parts = fileName.split("/");
        displayFileName = parts[parts.length - 1];
      } // Si no hay nombre pero hay tipo, usar el tipo como nombre


      var finalFileName = displayFileName || fileTypeLabel || "Archivo";
      var _updatedAt = currentData.updated_at;

      var _updatedByEmail = currentData.updated_by_email || version.whodunnit || "Desconocido"; // Usar created_at de current_data si está disponible (fecha de creación original del registro)
      // Si no, usar created_at de la versión (fecha de creación de la versión)


      var _createdAt = currentData.created_at || version.created_at;

      var _createdByEmail = currentData.created_by_email || version.whodunnit || "Desconocido"; // Solo mostrar fecha de edición si updated_at existe y es diferente de created_at
      // Usar una tolerancia de 1 segundo para evitar problemas de precisión


      var _createdDate = new Date(_createdAt).getTime();

      var _updatedDate = _updatedAt ? new Date(_updatedAt).getTime() : null;

      var _wasEdited = _updatedDate && Math.abs(_updatedDate - _createdDate) > 1000; // Más de 1 segundo de diferencia


      return {
        fecha: formatDate(_createdAt),
        fechaEdicion: _wasEdited ? formatDate(_updatedAt) : null,
        ejecutivo: _createdByEmail,
        ejecutivoEdicion: _wasEdited ? _updatedByEmail : null,
        tipoGestion: "",
        descripcion: "",
        medioContacto: "",
        proximoPaso: "",
        estado: "",
        archivo: finalFileName,
        archivoUrl: fileUrl,
        fileTypeRaw: fileTypeRaw,
        itemType: version.item_type,
        itemId: version.item_id,
        canEdit: admin.is_super_admin || admin.permissions_code.includes("poliza_file_edit"),
        canDelete: admin.is_super_admin || admin.permissions_code.includes("poliza_file_delete")
      };
    } // Para recordatorio de vencimiento


    if (version.item_type === "Poliza" && changes.expiration_reminder_sent_at) {
      return {
        fecha: formatDate(version.created_at),
        ejecutivo: version.whodunnit || "Desconocido",
        tipoGestion: "Recordatorio de vencimiento",
        descripcion: "Recordatorio de vencimiento enviado al cliente",
        medioContacto: "Email",
        proximoPaso: "",
        estado: "Enviado",
        archivo: "",
        itemType: version.item_type,
        itemId: null,
        canEdit: false,
        canDelete: false
      };
    }

    return null;
  }; // Procesar versiones y agrupar comentarios y archivos creados al mismo tiempo
  // Primero ordenar las versiones por id descendente (más recientes primero) para que la agrupación funcione correctamente


  var sortedVersions = _toConsumableArray(versions).sort(function (a, b) {
    var aId = a.id || 0;
    var bId = b.id || 0;
    return bId - aId; // Descendente: mayor id primero
  });

  var processedRows = sortedVersions.map(function (version) {
    var row = getRowData(version);

    if (row) {
      // Agregar la versión original para tener acceso a los datos completos
      row.version = version;
      row.createdAt = version.created_at; // Guardar timestamp para agrupar
    }

    return row;
  }).filter(function (row) {
    return row !== null;
  }); // Primero, agrupar por item_id y mantener solo la versión más reciente de cada item
  // Esto evita mostrar múltiples versiones "update" del mismo registro

  var itemsMap = new Map();
  processedRows.forEach(function (row) {
    // Solo procesar filas que tienen itemId válido
    if (!row.itemId) {
      return;
    }

    var key = "".concat(row.itemType, "_").concat(row.itemId);
    var existing = itemsMap.get(key);

    if (!existing) {
      itemsMap.set(key, row);
    } else {
      // Si ya existe, mantener la versión más reciente
      // Usar el id de la versión como criterio de desempate (más reciente = mayor id)
      var existingVersionId = existing.version.id || 0;
      var currentVersionId = row.version.id || 0;
      var existingTime = new Date(existing.version.created_at).getTime();
      var currentTime = new Date(row.version.created_at).getTime(); // Priorizar por id de versión (más reciente = mayor id), luego por timestamp

      if (currentVersionId > existingVersionId || currentVersionId === existingVersionId && currentTime > existingTime) {
        itemsMap.set(key, row);
      }
    }
  }); // Convertir el mapa de vuelta a array

  var uniqueRows = Array.from(itemsMap.values()); // Agrupar comentarios y archivos creados/actualizados al mismo tiempo (dentro de 5 segundos)

  var groupedRows = [];
  var processedIndices = new Set();
  uniqueRows.forEach(function (row, index) {
    if (processedIndices.has(index)) return; // Si es un comentario, buscar un archivo creado/actualizado al mismo tiempo

    if (row.itemType === "PolizaComment") {
      var commentTime = new Date(row.createdAt).getTime(); // Buscar un archivo creado/actualizado dentro de 5 segundos

      var matchingFileIndex = uniqueRows.findIndex(function (otherRow, otherIndex) {
        if (processedIndices.has(otherIndex)) return false;
        if (otherRow.itemType !== "PolizaFile") return false;
        if (otherRow.ejecutivo !== row.ejecutivo) return false; // Mismo ejecutivo

        var fileTime = new Date(otherRow.createdAt).getTime();
        var timeDiff = Math.abs(commentTime - fileTime);
        return timeDiff <= 5000; // 5 segundos
      });

      if (matchingFileIndex !== -1) {
        // Combinar comentario y archivo en una sola fila
        var fileRow = uniqueRows[matchingFileIndex];

        var combinedRow = _objectSpread(_objectSpread({}, row), {}, {
          // Preservar TODOS los campos del comentario (incluyendo estado, fechaEdicion, ejecutivoEdicion, etc.)
          // Mantener datos del comentario pero agregar el archivo
          archivo: fileRow.archivo || "",
          archivoUrl: fileRow.archivoUrl || "",
          // Solo usar la descripción del archivo si el comentario no tiene descripción
          // Pero NO sobrescribir si el comentario ya tiene descripción
          descripcion: row.descripcion || fileRow.descripcion || "",
          // Preservar explícitamente el estado del comentario (no debe ser sobrescrito por el archivo)
          estado: row.estado || "",
          estadoRaw: row.estadoRaw || "",
          // Agregar fileTypeRaw del archivo para uso en la columna de archivo
          fileTypeRaw: fileRow.fileTypeRaw || "",
          // Mantener permisos de ambos
          canEdit: row.canEdit || fileRow.canEdit,
          canDelete: row.canDelete || fileRow.canDelete,
          // Guardar ambos IDs para poder eliminar ambos
          commentId: row.itemId,
          fileId: fileRow.itemId,
          hasBoth: true,
          // Marca que esta fila combina ambos
          // Preservar también la versión del archivo para referencia
          fileVersion: fileRow.version
        });

        groupedRows.push(combinedRow);
        processedIndices.add(index);
        processedIndices.add(matchingFileIndex);
      } else {
        // No hay archivo coincidente, agregar solo el comentario
        groupedRows.push(row);
        processedIndices.add(index);
      }
    } else if (row.itemType === "PolizaFile") {
      // Si es un archivo, verificar si ya fue procesado con un comentario
      // (esto se maneja en el caso anterior)
      var fileTime = new Date(row.createdAt).getTime();
      var matchingCommentIndex = uniqueRows.findIndex(function (otherRow, otherIndex) {
        if (processedIndices.has(otherIndex)) return false;
        if (otherRow.itemType !== "PolizaComment") return false;
        if (otherRow.ejecutivo !== row.ejecutivo) return false;
        var commentTime = new Date(otherRow.createdAt).getTime();
        var timeDiff = Math.abs(commentTime - fileTime);
        return timeDiff <= 5000;
      });

      if (matchingCommentIndex === -1) {
        // No hay comentario coincidente, agregar solo el archivo
        groupedRows.push(row);
        processedIndices.add(index);
      } // Si hay comentario coincidente, ya se procesó en el caso anterior

    } else {
      // Para otros tipos de items (Poliza, etc.), agregar tal cual
      groupedRows.push(row);
      processedIndices.add(index);
    }
  });
  var tableRows = groupedRows;

  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card",
      style: {
        backgroundColor: "#f5f5f5"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-header",
      style: {
        padding: "10px 15px",
        backgroundColor: "#f8f9fa",
        borderBottom: "1px solid #dee2e6"
      }
    }, /*#__PURE__*/React.createElement("h5", {
      style: {
        margin: "0",
        fontSize: "16px",
        fontWeight: "600"
      }
    }, "Historial de Cambios")), /*#__PURE__*/React.createElement("div", {
      className: "card-body",
      style: {
        padding: "15px"
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "13px",
        color: "#666"
      }
    }, "Cargando historial...")));
  }

  if (error) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card",
      style: {
        backgroundColor: "#f5f5f5"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-header",
      style: {
        padding: "10px 15px",
        backgroundColor: "#f8f9fa",
        borderBottom: "1px solid #dee2e6"
      }
    }, /*#__PURE__*/React.createElement("h5", {
      style: {
        margin: "0",
        fontSize: "16px",
        fontWeight: "600"
      }
    }, "Historial de Cambios")), /*#__PURE__*/React.createElement("div", {
      className: "card-body",
      style: {
        padding: "15px"
      }
    }, /*#__PURE__*/React.createElement("p", {
      style: {
        fontSize: "13px",
        color: "#d32f2f"
      }
    }, "Error al cargar el historial")));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "version-history-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card",
    style: {
      backgroundColor: "#f5f5f5",
      border: "1px solid #dee2e6"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header",
    style: {
      padding: "10px 15px",
      backgroundColor: "#f8f9fa",
      borderBottom: "1px solid #dee2e6"
    }
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600"
    }
  }, "Historial de Cambios")), /*#__PURE__*/React.createElement("div", {
    className: "card-body",
    style: {
      padding: "15px",
      backgroundColor: "#fff"
    }
  }, tableRows.length === 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "20px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: "13px",
      color: "#666"
    }
  }, "No hay historial de cambios registrado.")) : /*#__PURE__*/React.createElement("div", null, tableRows.map(function (row, index) {
    var _editData$management_, _editData$status, _editData$contact_met, _editData$next_step, _editData$new_file, _editData$file_type;

    var isEditing = editingRow === index;
    var isComment = row.itemType === "PolizaComment" || row.hasBoth;
    var isFile = row.itemType === "PolizaFile";
    var hasBoth = row.hasBoth || false; // Renderizar badge de estado

    var renderStatusBadge = function renderStatusBadge() {
      if (!isComment) return null;
      var estado = row.estado || row.estadoRaw || "";
      if (!estado) return null;
      var badgeClass = "label label-default";
      if (estado === "Pendiente") badgeClass = "label label-default";else if (estado === "En proceso") badgeClass = "label label-warning";else if (estado === "Cerrado") badgeClass = "label label-success";
      return /*#__PURE__*/React.createElement("span", {
        className: badgeClass
      }, estado);
    }; // Renderizar información de ejecutivo y fechas


    var renderEjecutivoInfo = function renderEjecutivoInfo() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "14px",
          marginBottom: "4px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Estado:"), " ", renderStatusBadge() || "-"), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "14px",
          marginBottom: "4px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Ejecutivo:"), " ", row.ejecutivo || "-", row.ejecutivoEdicion && row.ejecutivoEdicion !== row.ejecutivo && /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "13px",
          color: "#666",
          marginLeft: "8px"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Editado por:"), " ", row.ejecutivoEdicion)), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "14px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Fecha creaci\xF3n:"), " ", row.fecha || "-", row.fechaEdicion && /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "13px",
          color: "#666",
          marginLeft: "8px"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Fecha edici\xF3n:"), " ", row.fechaEdicion)));
    };

    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "row no-gutters",
      style: {
        paddingLeft: "15px",
        paddingRight: "15px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "col col-sm-3"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "4px"
      }
    }, isEditing && isComment && editData ? /*#__PURE__*/React.createElement("select", {
      value: (_editData$management_ = editData.management_type) !== null && _editData$management_ !== void 0 ? _editData$management_ : "",
      onChange: function onChange(e) {
        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            management_type: e.target.value || null
          }));
        }
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px"
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Seleccionar..."), MANAGEMENT_TYPES.map(function (type) {
      return /*#__PURE__*/React.createElement("option", {
        key: type.value,
        value: type.value
      }, type.label);
    })) : /*#__PURE__*/React.createElement("div", null, row.tipoGestion ? /*#__PURE__*/React.createElement("span", {
      className: "badge",
      style: {
        backgroundColor: "#2596be",
        color: "#fff"
      }
    }, row.tipoGestion) : null)), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "14px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Descripci\xF3n:"), " ", isEditing && isComment && editData ? /*#__PURE__*/React.createElement("textarea", {
      value: (editData === null || editData === void 0 ? void 0 : editData.content) || "",
      onChange: function onChange(e) {
        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            content: e.target.value
          }));
        }
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        minHeight: "60px",
        marginTop: "2px"
      },
      rows: 3
    }) : /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "4px"
      }
    }, row.descripcion || "-"))), /*#__PURE__*/React.createElement("div", {
      className: "col col-sm-2"
    }, isEditing && isComment ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "4px"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Estado:"), /*#__PURE__*/React.createElement("select", {
      value: (_editData$status = editData === null || editData === void 0 ? void 0 : editData.status) !== null && _editData$status !== void 0 ? _editData$status : "",
      onChange: function onChange(e) {
        var newStatus = e.target.value === "" ? null : e.target.value;

        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            status: newStatus
          }));
        }
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        marginTop: "2px"
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Seleccionar..."), STATUS_OPTIONS.map(function (status) {
      return /*#__PURE__*/React.createElement("option", {
        key: status.value,
        value: status.value
      }, status.label);
    }))), /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "4px"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Ejecutivo:"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: row.ejecutivo || "",
      disabled: true,
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        backgroundColor: "#f5f5f5",
        marginTop: "2px"
      }
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Fecha creaci\xF3n:"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: row.fecha || "",
      disabled: true,
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        backgroundColor: "#f5f5f5",
        marginTop: "2px"
      }
    }))) : renderEjecutivoInfo()), /*#__PURE__*/React.createElement("div", {
      className: "col col-sm-2"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "14px",
        marginBottom: "8px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Medio de Contacto:"), isEditing && isComment ? /*#__PURE__*/React.createElement("select", {
      value: (_editData$contact_met = editData === null || editData === void 0 ? void 0 : editData.contact_method) !== null && _editData$contact_met !== void 0 ? _editData$contact_met : "",
      onChange: function onChange(e) {
        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            contact_method: e.target.value || null
          }));
        }
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        marginTop: "2px"
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Seleccionar..."), CONTACT_METHODS.map(function (method) {
      return /*#__PURE__*/React.createElement("option", {
        key: method.value,
        value: method.value
      }, method.label);
    })) : /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "4px"
      }
    }, row.medioContacto || "-")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "14px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Pr\xF3ximo Paso:"), isEditing && isComment ? /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: (_editData$next_step = editData === null || editData === void 0 ? void 0 : editData.next_step) !== null && _editData$next_step !== void 0 ? _editData$next_step : "",
      onChange: function onChange(e) {
        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            next_step: e.target.value || null
          }));
        }
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        marginTop: "2px"
      }
    }) : /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "4px"
      }
    }, row.proximoPaso || "-"))), /*#__PURE__*/React.createElement("div", {
      className: "col col-sm-2"
    }, isEditing && editData ? hasBoth || isFile || isComment ? /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "8px"
      }
    }, (editData === null || editData === void 0 ? void 0 : editData.current_file_name) && !(editData !== null && editData !== void 0 && editData.delete_file) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Archivo:"), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "4px",
        backgroundColor: "#f8f9fa",
        borderRadius: "4px",
        marginTop: "2px"
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-file-pdf-o",
      style: {
        fontSize: "16px",
        color: "#dc3545"
      }
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "14px",
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, String((editData === null || editData === void 0 ? void 0 : editData.current_file_name) || "")), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            delete_file: true,
            new_file: null
          }));
        }
      },
      style: {
        background: "#dc3545",
        color: "white",
        border: "none",
        borderRadius: "4px",
        padding: "2px 6px",
        fontSize: "11px",
        cursor: "pointer"
      },
      title: "Eliminar archivo actual"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-trash"
    })))), (!(editData !== null && editData !== void 0 && editData.current_file_name) || (editData === null || editData === void 0 ? void 0 : editData.delete_file) || !hasBoth) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Archivo:"), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "11px",
        marginBottom: "4px",
        display: "block",
        marginTop: "2px"
      }
    }, editData !== null && editData !== void 0 && editData.current_file_name && editData !== null && editData !== void 0 && editData.delete_file ? "Subir nuevo archivo:" : editData !== null && editData !== void 0 && editData.new_file ? "Archivo seleccionado: ".concat(((_editData$new_file = editData.new_file) === null || _editData$new_file === void 0 ? void 0 : _editData$new_file.name) || "archivo") : "Subir archivo:"), /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: ".pdf",
      onChange: function onChange(e) {
        var _e$target$files;

        var file = (_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];

        if (file && editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            new_file: file,
            delete_file: false
          }));
        }
      },
      style: {
        fontSize: "11px",
        padding: "2px",
        width: "100%"
      }
    })), ((editData === null || editData === void 0 ? void 0 : editData.current_file_name) || (editData === null || editData === void 0 ? void 0 : editData.new_file) || hasBoth || isFile) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, "Tipo:"), /*#__PURE__*/React.createElement("select", {
      value: (_editData$file_type = editData === null || editData === void 0 ? void 0 : editData.file_type) !== null && _editData$file_type !== void 0 ? _editData$file_type : "",
      onChange: function onChange(e) {
        if (editData) {
          setEditData(_objectSpread(_objectSpread({}, editData), {}, {
            file_type: e.target.value || null
          }));
        }
      },
      style: {
        width: "100%",
        padding: "4px",
        fontSize: "14px",
        marginTop: "2px"
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Seleccionar tipo..."), FILE_TYPES.map(function (type) {
      return /*#__PURE__*/React.createElement("option", {
        key: type.value,
        value: type.value
      }, type.label);
    })))) : /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "14px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "4px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Archivo:"), " ", /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "4px"
      }
    }, "-")), /*#__PURE__*/React.createElement("div", {
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }
    }, /*#__PURE__*/React.createElement("strong", null, "Tipo:"), " ", /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "4px"
      }
    }, "-"))) : function () {
      var _FILE_TYPES$find2;

      var fileTypeLabel = row.fileTypeRaw ? ((_FILE_TYPES$find2 = FILE_TYPES.find(function (ft) {
        return ft.value === row.fileTypeRaw;
      })) === null || _FILE_TYPES$find2 === void 0 ? void 0 : _FILE_TYPES$find2.label) || row.fileTypeRaw : "";
      return /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: "14px"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: "4px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Archivo:"), row.archivo ? /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: "4px"
        }
      }, row.archivoUrl ? /*#__PURE__*/React.createElement("a", {
        href: row.archivoUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          fontSize: "14px",
          display: "inline",
          cursor: "pointer",
          color: "#2596be"
        },
        onClick: function onClick(e) {
          e.preventDefault();
          setModalFile({
            url: row.archivoUrl,
            name: row.archivo
          });
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-file-text-o text-primary",
        style: {
          marginRight: '5px',
          fontSize: '1.1em'
        }
      }), /*#__PURE__*/React.createElement("span", null, row.archivo)) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-file-pdf-o",
        style: {
          fontSize: "18px",
          color: "#dc3545",
          marginRight: "6px"
        }
      }), /*#__PURE__*/React.createElement("span", null, row.archivo))) : /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: "4px"
        }
      }, "-")), /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }
      }, /*#__PURE__*/React.createElement("strong", null, "Tipo:"), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: "4px"
        }
      }, fileTypeLabel || "-")));
    }()), /*#__PURE__*/React.createElement("div", {
      className: "col col-sm-1"
    }, (row.canEdit || row.canDelete) && /*#__PURE__*/React.createElement("div", null, isEditing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      className: "btn btn-xs btn-success",
      onClick: function onClick() {
        return handleSaveEdit(row);
      },
      disabled: loadingEdit,
      style: {
        padding: "4px 8px",
        fontSize: "11px",
        width: "100px",
        marginBottom: "10px"
      }
    }, loadingEdit ? "Guardando..." : "Guardar"), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-xs btn-default",
      onClick: handleCancelEdit,
      disabled: loadingEdit,
      style: {
        padding: "4px 8px",
        fontSize: "11px",
        width: "100px"
      }
    }, "Cancelar")) : /*#__PURE__*/React.createElement(React.Fragment, null, row.canEdit && /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "btn btn-primary",
      onClick: function onClick(e) {
        e.preventDefault();
        handleStartEdit(row, index);
      },
      disabled: loadingEdit,
      style: {
        marginBottom: "10px",
        width: "100px"
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-edit"
    }), " Editar"), row.canDelete && /*#__PURE__*/React.createElement("button", {
      className: "btn btn-xs btn-danger",
      onClick: function onClick() {
        if (row.hasBoth) {
          if (confirm("¿Está seguro de eliminar el comentario y el archivo?")) {
            var promises = [];

            if (row.commentId) {
              promises.push(handleDeleteComment(row.commentId));
            }

            if (row.fileId) {
              promises.push(handleDeleteFile(row.fileId));
            }

            Promise.all(promises)["catch"](function (error) {
              console.error("Error deleting:", error);
            });
          }
        } else if (row.itemType === "PolizaComment") {
          if (confirm("¿Está seguro de eliminar este comentario?")) {
            handleDeleteComment(row.itemId);
          }
        } else if (row.itemType === "PolizaFile") {
          if (confirm("¿Está seguro de eliminar este archivo?")) {
            handleDeleteFile(row.itemId);
          }
        }
      },
      style: {
        padding: "4px 8px",
        fontSize: "11px",
        width: "100px"
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "glyphicon glyphicon-trash"
    }), " Eliminar")))));
  })))), modalFile && /*#__PURE__*/React.createElement(FileModal, {
    fileUrl: modalFile.url,
    fileName: modalFile.name,
    onClose: function onClose() {
      return setModalFile(null);
    }
  }));
};

export default VersionHistorySection;